import { SectionsInterface } from '../../field.interface';

export class Feature32Layout {
	sections: SectionsInterface[] = [
		{
			title: 'Feature',
			items: [
				// [
				// 	{
				// 		cssClass: 'col-md-6',
				// 		options: {
				// 			path: 'InspectionReport.property.features[{index}].type'
				// 		}
				// 	}
				// ],
				[
					{
						cssClass: 'col-md-12',
						options: {
							path: 'InspectionReport.property.features[{index}].description'
						}
					}
				]
			]
		}
	];
}
